export default __webpack_public_path__ + "static/promo-card-platform-8b021c07c18ce474d788da0507ad1442.png";